import { Box, Button, TextField } from "@mui/material"

const PublicBarcodeForm = ({ barcode, onBarcodeChange, onSubmit }) => {
  return (
    <Box
      component="form"
      aria-label="Start pet test registration"
      onSubmit={e => {
        e.preventDefault()
        onSubmit()
      }}
      sx={{
        backgroundColor: "#3E4755",
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        padding: { xs: "1rem", md: "1.1rem" },
        flexWrap: "wrap",
        borderRadius: "10px",
        width: "100%",
        marginTop: "2rem",
        marginBottom: "2rem",
        border: "1px solid rgba(255,255,255,0.1)",
        boxShadow: "0 14px 30px rgba(15, 23, 42, 0.18)"
      }}
    >
      <div style={{ width: "min(100%, 210px)" }}>
        <TextField
          id="barcode"
          variant="outlined"
          value={barcode || ""}
          size="small"
          fullWidth
          onChange={onBarcodeChange}
          label="Enter Your Code"
          inputProps={{
            "aria-label": "Enter the barcode printed on the card inside your test kit",
            autoComplete: "off"
          }}
          InputLabelProps={{
            style: { color: "#D8DDE6" }
          }}
          InputProps={{
            style: {
              color: "#FFFFFF"
            }
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              backgroundColor: "rgba(255,255,255,0.04)"
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255,255,255,0.42)"
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#FFFFFF"
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#FFFFFF",
              borderWidth: 1
            }
          }}
        />
      </div>
      <div>
        <Button
          className="py-2 btn btn_bg_secondery"
          variant="contained"
          type="submit"
          aria-label="Register test with entered barcode"
          sx={{
            borderRadius: "8px",
            minHeight: 40,
            minWidth: 146,
            px: 3,
            boxShadow: "0 8px 18px rgba(15, 23, 42, 0.24)",
            textTransform: "none",
            fontWeight: 400,
            whiteSpace: "nowrap"
          }}
        >
          Register Test
        </Button>
      </div>
    </Box>
  )
}

export default PublicBarcodeForm
